import { connect } from 'react-redux';

import HeaderComponent from '../components/Header';

import { isAuthenticatedSelector } from '../reducers/auth';

import { logout } from '../actions/auth';

import {
  isNavigationOpenSelector,
  headerTypeSelector,
} from '../reducers/navigation';

import { toggleNavigation } from '../actions/navigation';

const mapStateToProps = state => {
  return {
    isAuthenticated: isAuthenticatedSelector(state),
    isNavigationOpen: isNavigationOpenSelector(state),
    headerType: headerTypeSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout()),
    toggleNavigation: () => dispatch(toggleNavigation()),
  };
};

const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);

export default Header;